export default {
      id: "ar_espace_culturel-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ar_espace_culturel-usage",
      toString: function () {
        return this.url;
      }
    }